import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class ResizeBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.resize = {
            init: (node: HTMLElement, valueAccessor: () => OptionsType) => {
                let options = valueAccessor();
                let method = options.method || 'throttle';
                let delay = options.delay || 100;
                let delayed;

                if (method != 'none') {
                    delayed = _[method](() => {
                        options.callback(node);
                    }, delay);
                }
                else {
                    delayed = () => {
                        options.callback(node);
                    };
                }
                const resizeObserver = new ResizeObserver(delayed);
                resizeObserver.observe(node);

                ko.utils.domNodeDisposal.addDisposeCallback(node, () => {
                    resizeObserver.unobserve(node);
                });
            }
        };
    }
}

type OptionsType = {
    method: string,
    delay: number,
    callback: (node) => void
}